import React, { useState } from 'react';
import { t } from '../i18n';

function Contact({ user }) {
  const [form, setForm] = useState({ name: user?.username || '', email: '', subject: '', message: '' });
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!form.name || !form.email || !form.message) { alert('Please fill all fields!'); return; }
    setLoading(true);
    try {
      const res = await fetch('/api/contact/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      });
      if (res.ok) setSent(true);
      else alert('Failed to send. Please try again.');
    } catch (err) { alert('Network error. Please try again.'); }
    setLoading(false);
  };

  if (sent) return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={{ fontSize: '60px', textAlign: 'center' }}>✅</div>
        <h2 style={styles.heading}>{t('ct_sent')}</h2>
        <p style={{ textAlign: 'center', color: '#666' }}>{t('ct_soon')}</p>
        <button style={styles.btn} onClick={() => setSent(false)}>{t('ct_again')}</button>
      </div>
    </div>
  );

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.heading}>{t('ct_title')}</h2>
        <p style={styles.sub}>{t('ct_tag')}</p>
        <input style={styles.input} placeholder={t('ct_name')} value={form.name} onChange={e => setForm({...form, name: e.target.value})} />
        <input style={styles.input} placeholder={t('ct_email')} type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} />
        <input style={styles.input} placeholder={t('ct_sub')} value={form.subject} onChange={e => setForm({...form, subject: e.target.value})} />
        <textarea style={styles.textarea} placeholder={t('ct_msg')} rows={5} value={form.message} onChange={e => setForm({...form, message: e.target.value})} />
        <button style={styles.btn} onClick={handleSubmit} disabled={loading}>
          {loading ? 'Sending...' : '🚀 Send Message'}
        </button>
        <div style={styles.links}>
          <a href="https://twitter.com/xpertcreation" target="_blank" rel="noopener noreferrer" style={styles.socialBtn('#000')}>𝕏 Twitter</a>
          <a href="https://discord.gg/xpertcreation" target="_blank" rel="noopener noreferrer" style={styles.socialBtn('#5865F2')}>Discord</a>
          <a href="https://xpertcreation.com" target="_blank" rel="noopener noreferrer" style={styles.socialBtn('#6200ea')}>🌐 Website</a>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: { maxWidth: '600px', margin: '20px auto', padding: '20px' },
  card: { backgroundColor: 'white', borderRadius: '16px', padding: '30px', boxShadow: '0 4px 20px rgba(0,0,0,0.1)' },
  heading: { color: '#6200ea', textAlign: 'center', marginBottom: '8px' },
  sub: { color: '#999', textAlign: 'center', fontSize: '14px', marginBottom: '20px' },
  input: { width: '100%', padding: '12px', borderRadius: '10px', border: '2px solid #e0e0e0', fontSize: '15px', marginBottom: '12px', boxSizing: 'border-box' },
  textarea: { width: '100%', padding: '12px', borderRadius: '10px', border: '2px solid #e0e0e0', fontSize: '15px', marginBottom: '12px', boxSizing: 'border-box', resize: 'vertical', fontFamily: 'inherit' },
  btn: { width: '100%', backgroundColor: '#6200ea', color: 'white', border: 'none', padding: '14px', borderRadius: '10px', fontSize: '16px', cursor: 'pointer', fontWeight: 'bold', marginBottom: '16px' },
  links: { display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap' },
  socialBtn: (bg) => ({ backgroundColor: bg, color: 'white', padding: '8px 16px', borderRadius: '20px', textDecoration: 'none', fontSize: '13px', fontWeight: 'bold' }),
};

export default Contact;
